import {
  usePermissions,
  useGetTaskGroupsPaginated,
} from '@dispatch/shared/hooks';
import { TaskGroups } from '@dispatch/web/features/task-groups';
import React, { useState } from 'react';
import { TaskGroupsListFilter } from '@dispatch/shared/types';
import { Outlet } from 'react-router-dom';
import { useDebounce } from 'react-use';
import { isEmpty } from 'lodash';

const TaskGroupsPage = () => {
  const defaultFilters: TaskGroupsListFilter = {
    pageSize: 10,
  };

  const { permissions } = usePermissions();
  const [filters, setFilters] = useState(defaultFilters);

  const [debouncedFilters, setDebouncedFilters] = React.useState<{
    filters: TaskGroupsListFilter;
  }>({ filters: {} as TaskGroupsListFilter });

  useDebounce(() => setDebouncedFilters({ filters }), 500, [filters]);

  const taskGroups = useGetTaskGroupsPaginated(
    debouncedFilters.filters,
    !isEmpty(debouncedFilters.filters)
  );

  const onSearch = (value: string) => {
    setFilters({ ...filters, taskGroupName: value });
    taskGroups?.goToFirstPage();
  };

  return (
    <>
      <TaskGroups
        rows={taskGroups}
        onFilterChange={setFilters}
        onSearch={onSearch}
        filters={filters}
        permissions={permissions}
      />
      <Outlet />
    </>
  );
};

export default TaskGroupsPage;
